var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEyeOff(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.99976 3L6.58891 6.58916M20.9998 21L17.411 17.4112M13.8746 18.8246C13.2675 18.9398 12.6409 19 12.0002 19C7.52256 19 3.73226 16.0571 2.45801 12C2.80491 10.8955 3.33826 9.87361 4.02119 8.97118M9.87844 9.87868C10.4213 9.33579 11.1713 9 11.9998 9C13.6566 9 14.9998 10.3431 14.9998 12C14.9998 12.8284 14.664 13.5784 14.1211 14.1213M9.87844 9.87868L14.1211 14.1213M9.87844 9.87868L6.58891 6.58916M14.1211 14.1213L6.58891 6.58916M14.1211 14.1213L17.411 17.4112M6.58891 6.58916C8.14874 5.58354 10.0063 5 12.0002 5C16.4778 5 20.2681 7.94291 21.5424 12C20.8355 14.2507 19.3543 16.1585 17.411 17.4112",
    stroke: "#111827",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOff);
export default __webpack_public_path__ + "static/media/eye-off.b0cd0c21c0f498831ca80615f466de66.svg";
export { ForwardRef as ReactComponent };